import React from 'react';
import PropTypes from 'prop-types';
import styles from './title.module.scss';
import clsx from 'clsx';
export const Title = props => {
  const { className, children, fontSize = 20, color = '#505050' } = props;
  return (
    <h3 className={clsx(styles.title, className)} style={{fontSize: `${fontSize}px`, color}}>{children}</h3>
  );
};

Title.propTypes = {
  className: PropTypes.string,
  fontSize: PropTypes.number
};

export default Title;
